import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import NotificationButton from "./NotificationButton";
import { obtenerRutaPublica } from "../utils/rutaPublica";

const DashboardHeader = ({ onToggleSidebar }) => {
  const navigate = useNavigate();
  const menuRef = useRef(null);

  const [instructor, setInstructor] = useState(null);
  const [menuAbierto, setMenuAbierto] = useState(false);

  // ======================================================
  // CARGAR INSTRUCTOR DE LA SESIÓN
  // ======================================================
  useEffect(() => {
    const cargarInstructorSesion = async () => {
      try {
        const token =
          localStorage.getItem("token") ||
          sessionStorage.getItem("token") ||
          "";

        if (!token) return;

        // ======================================================
        // DECODIFICAR TOKEN
        // ======================================================
        let usuarioToken = {};

        try {
          const payload = token.split(".")[1];

          if (payload) {
            usuarioToken = JSON.parse(atob(payload));
          }
        } catch (error) {
          console.error(
            "Error decodificando token:",
            error
          );

          return;
        }

        const instructorId =
          usuarioToken?._id ||
          usuarioToken?.id ||
          usuarioToken?.uid ||
          usuarioToken?.instructorObjectId ||
          usuarioToken?.usuario?._id ||
          "";

        if (!instructorId) return;

        // ======================================================
        // CONSULTAR PERFIL
        // ======================================================
        const { data } = await axios.get(
          "/api/perfil",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (data?.ok) {
          setInstructor(
            data.message || {}
          );
        }
      } catch (error) {
        console.error(
          "Error cargando instructor de sesión:",
          error?.response?.data ||
            error?.message ||
            error
        );
      }
    };

    cargarInstructorSesion();
  }, []);

  // ======================================================
  // CERRAR MENÚ AL HACER CLIC FUERA
  // ======================================================
  useEffect(() => {
    const cerrarMenu = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        setMenuAbierto(false);
      }
    };

    document.addEventListener(
      "mousedown",
      cerrarMenu
    );

    return () => {
      document.removeEventListener(
        "mousedown",
        cerrarMenu
      );
    };
  }, []);

  // ======================================================
  // CERRAR SESIÓN
  // ======================================================
  const cerrarSesion = () => {
    localStorage.clear();
    sessionStorage.clear();

    navigate(obtenerRutaPublica(), { replace: true });
  };

  // ======================================================
  // DATOS DEL INSTRUCTOR
  // ======================================================
  const nombreCompleto = [
    instructor?.nombre1Instructor,
    instructor?.nombre2Instructor,
    instructor?.apellido1Instructor,
    instructor?.apellido2Instructor,
  ]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();

  const userImage =
    instructor?.imgInstructor || "";

  const rolUsuario =
    instructor?.rolObjectId?.nombreRol ||
    "Usuario";

  // ======================================================
  // RENDER
  // ======================================================
  return (
    <nav className="navbar navbar-light bg-light shadow-sm fixed-top px-2 px-md-4 py-2">
      <div className="container-fluid d-flex align-items-center justify-content-between gap-2 flex-nowrap">

        {/* ==================================================
            IZQUIERDA
        ================================================== */}
        <div className="d-flex align-items-center gap-2 gap-md-3 flex-grow-1 overflow-hidden">

          {/* BOTÓN SIDEBAR MÓVIL */}
          <button
            className="btn btn-outline-secondary d-md-none flex-shrink-0"
            type="button"
            onClick={onToggleSidebar}
            aria-label="Abrir menú lateral"
          >
            <i className="fas fa-bars"></i>
          </button>

          {/* INFORMACIÓN DEL USUARIO */}
          <div className="d-flex flex-column lh-sm overflow-hidden">
            <span className="fw-bold text-dark text-truncate">
              {nombreCompleto || "Usuario"}
            </span>

            <small className="text-muted text-truncate">
              {rolUsuario}
            </small>
          </div>
        </div>

        {/* ==================================================
            DERECHA
        ================================================== */}
        <div className="d-flex align-items-center gap-2 gap-md-3 flex-shrink-0">

          {/* NOTIFICACIONES */}
          <NotificationButton />

          {/* ==================================================
              PERFIL
          ================================================== */}
          <div
            className="position-relative"
            ref={menuRef}
          >
            <button
              type="button"
              className="btn p-0 border-0 bg-transparent"
              onClick={() =>
                setMenuAbierto(
                  (prev) => !prev
                )
              }
              aria-label="Menú de usuario"
              aria-expanded={menuAbierto}
            >
              {userImage ? (
                <img
                  src={userImage}
                  alt={
                    nombreCompleto ||
                    "Usuario"
                  }
                  className="rounded-circle border shadow-sm"
                  width="42"
                  height="42"
                  style={{
                    objectFit: "cover",
                    border:
                      "2px solid #dee2e6",
                  }}
                  onError={(e) => {
                    e.currentTarget.style.display =
                      "none";
                  }}
                />
              ) : (
                <div
                  className="rounded-circle bg-secondary d-flex align-items-center justify-content-center text-white shadow-sm"
                  style={{
                    width: 42,
                    height: 42,
                  }}
                >
                  <i className="fa-solid fa-user"></i>
                </div>
              )}
            </button>

            {/* ==================================================
                MENÚ DESPLEGABLE
            ================================================== */}
            {menuAbierto && (
              <div
                className="position-absolute end-0 mt-2 bg-white border rounded-4 shadow-sm overflow-hidden"
                style={{
                  minWidth: 230,
                  maxWidth:
                    "calc(100vw - 20px)",
                  zIndex: 2000,
                }}
              >

                {/* DATOS DEL USUARIO */}
                <div className="p-3 border-bottom">
                  <div className="fw-bold text-dark text-truncate">
                    {nombreCompleto ||
                      "Usuario"}
                  </div>

                  <small className="text-muted text-truncate d-block">
                    {rolUsuario}
                  </small>
                </div>

                {/* MI PERFIL */}
                <button
                  type="button"
                  className="dropdown-item px-3 py-2"
                  onClick={() => {
                    setMenuAbierto(false);
                    navigate("/perfil");
                  }}
                >
                  <i className="fa-solid fa-user me-2"></i>
                  Mi perfil
                </button>

                {/* CERRAR SESIÓN */}
                <button
                  type="button"
                  className="dropdown-item px-3 py-2 text-danger"
                  onClick={cerrarSesion}
                >
                  <i className="fa-solid fa-right-from-bracket me-2"></i>
                  Cerrar sesión
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default DashboardHeader;
